import { render } from "./PlcResetButtonAction.vue?vue&type=template&id=1f913b5a"
import script from "./PlcResetButtonAction.vue?vue&type=script&lang=js"
export * from "./PlcResetButtonAction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__